import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Header from "../components/Header";
import SearchInput from "../../../ui/SearchInput";
import Accordion from "../../../ui/Accordion";
import Modal from "../../../ui/Modal";

import { Formik, Field, isEmptyArray } from "formik";
import Form, { InputSection } from "../components/Form";
import Input from "../../../ui/Input";
import { DropDown, DropDownOptionsProps } from "../../../ui/DropDown";
import { postEndpoint, GetHook, putEndpoint } from "../../../api/api";
import { KPI_URL } from "../../../api/urls";
import { get } from "../../../utils/get";
import { useParams, useLocation } from "react-router-dom";
import Axios from "../../../utils/axios";
import { TitleText } from "../../../ui/Text";
import { Button } from "../../../ui/Button";
import AlignmentOptions from "../Scorecard/KpiForms/AlignmentOptions";
import { ScorecardIcon } from "../../../assets/svg/ScorecardIcon";
import { OrganisationTypeIcon } from "../../../assets/svg/OrganisationTypeIcon";
import { SettingsIcon } from "../../../assets/svg/SettingsIcon";
import { toast } from "react-toastify";
import { CloseIcon } from "../../../assets/svg/CloseIcon";
import { CloseIcon2 } from "../../../assets/svg/CloseIcon2";
import Swal from "sweetalert2";
import { KPI360Schema } from "../../../utils/validationSchema/ScorecardConfigSchema/KPIschema";
import { KPIQuestions } from "../Scorecard/KpiForms/KPIQuestions";
import { is360Subject } from "../../../subjects/Is360Subject";

interface InitialValues {
  name: string;
  questions: any[];
  prompt: string;
  answer1?: string;
  answer2?: string;
  answer3?: string;
  answer4?: string;
  answer5?: string;
}

const KPIConfigComponent360 = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const [kpis, setKpis] = useState<any>();
  const [isEdit, setIsEdit] = useState(false);
  const [kpiId, setKpiId] = useState();
  const [editData, setEditData] = useState<any>([]);
  const [step, setStep] = useState(1);
  const [totalSteps, _] = useState(is360Subject.value ? 2 : 1);
  const [scoringMatrix, setScoringMatrix] = useState<any>([]);

  const { id } = useParams<{ id: string }>();

  const { data, error, pending, reload } = GetHook(
    `${KPI_URL}?objective_id=${id}`
  );

  const formRef: any = useRef<any>(null);
  const location = useLocation();

  const isAddMode = !kpiId;

  useEffect(() => {
    setKpis(data);
    return () => {};
  }, [id, data]);

  const handleAddKpi = (values: InitialValues) => {
    const kpi_questions = values.questions.map((question) => {
      return {
        question: get(question, "prompt", ""),
        answers: [
          get(question, "answer1") && {
            answer: get(question, "answer1"),
            points: 1,
          },
          get(question, "answer2") && {
            answer: get(question, "answer2"),
            points: 2,
          },
          get(question, "answer3") && {
            answer: get(question, "answer3"),
            points: 3,
          },
          get(question, "answer4") && {
            answer: get(question, "answer4"),
            points: 4,
          },
          get(question, "answer5") && {
            answer: get(question, "answer5"),
            points: 5,
          },
        ].filter(Boolean),
      };
    });
    const payload = {
      name: get(values, "name"),
      objective_id: id,
      kpi_questions: kpi_questions.length > 0 ? kpi_questions : undefined,
    };
    createReq(KPI_URL, payload);
    
  };

  
  

  const editKpi = (values) => {
    const kpi_questions = values.questions.map((question) => {
      return {
        question: get(question, "prompt", ""),
        answers: [
          get(question, "answer1") && {
            answer: get(question, "answer1"),
            points: 1,
          },
          get(question, "answer2") && {
            answer: get(question, "answer2"),
            points: 2,
          },
          get(question, "answer3") && {
            answer: get(question, "answer3"),
            points: 3,
          },
          get(question, "answer4") && {
            answer: get(question, "answer4"),
            points: 4,
          },
          get(question, "answer5") && {
            answer: get(question, "answer5"),
            points: 5,
          },
        ].filter(Boolean),
      };
    });
    const payload: any = {
      name: get(values, "name"),
      objective_id: id,
      kpi_questions: kpi_questions.length > 0 ? kpi_questions : undefined,
    };
    updateReq(`${KPI_URL}/${kpiId}`, payload);
  };

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      toast.success("Kpi added successfully");
      reload(get(location, "key"));
      setisModalOpen(false);
    }

    return () => {};
  }, [createRes]);

  const setEdit = (kpi) => {
    setIsEdit(true);
    setKpiId(kpi.id);
    setEditData(kpi);
    setisModalOpen(true);
  };

  const closeModal = () => {
    setisModalOpen(false);
    setIsEdit(false);
    setKpiId(undefined);
    setStep(1);
    formRef.current.resetForm(initialValues);
  };
  useEffect(() => {
    if (!isAddMode && isEdit) {
      const newEditData = {
        name: get(editData, "name"),
        questions: get(editData, "kpi_questions", []).map((question) => {
          return {
            prompt: get(question, "question"),
            answer1: get(question, "answers[0].answer"),
            answer2: get(question, "answers[1].answer"),
            answer3: get(question, "answers[2].answer"),
            answer4: get(question, "answers[3].answer"),
            answer5: get(question, "answers[4].answer"),
          };
        }),
      };
      const fields = ["name", "supported_kpi", "questions"];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
    }
  }, [isAddMode]);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) toast.error(get(data, "message"));
    if (!pending && complete && !error) {
      toast.success("Kpi updated successfully");
      closeModal();
      reload(get(location, "key"));
    }
  }, [setisModalOpen, updateRes]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${KPI_URL}/${id}`)
            .then((res) => {
              setKpis(kpis.filter((kpi: any) => kpi.id != id));
              toast.success("KPI has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    setStep(step - 1);
  };

  const renderAddKpi = (formikBag) => {
    switch (step) {
      case 1:
        return (
          <Form>
            <InputSection>
              <Field
                name="name"
                placeholder="enter kpi name"
                label="KPI name"
                component={Input}
                width="96%"
                isBordered={true}
              />
            </InputSection>
          </Form>
        );
      case 2:
        return is360Subject.value && <KPIQuestions formikBag={formikBag} />;
    }
  };
  const initialValues: InitialValues = isEdit
    ? {
        name: "",
        questions: [],
        prompt: "",
        answer1: "",
        answer2: "",
        answer3: "",
        answer4: "",
        answer5: "",
      }
    : {
        name: "",
        questions: [],
        prompt: "",
        answer1: "",
        answer2: "",
        answer3: "",
        answer4: "",
        answer5: "",
      };

  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={KPI360Schema}
      onSubmit={isAddMode ? (values) => handleAddKpi(values) : editKpi}
    >
      {(formikBag) => (
        <KPIsContainer>
          <Header title="KPIs" setisModalOpen={setisModalOpen} />
          {isModalOpen && (
            <Modal
              title={!isEdit ? "Add new KPI" : "Edit kpi"}
              handleSubmit={formikBag.handleSubmit}
              closeModal={closeModal}
              noFooter
            >
              <WizzardHeader>
                <HeaderItem enabled={step === 1 ? true : false}>
                  <ScorecardIcon isActive />
                  <TitleText>KPI parameters</TitleText>
                </HeaderItem>
                {is360Subject.value && (
                  <HeaderItem enabled={step === 2 ? true : false}>
                    <SettingsIcon isActive />
                    <TitleText>Questions</TitleText>
                  </HeaderItem>
                )}
              </WizzardHeader>
              {renderAddKpi(formikBag)}
              <Footer>
                <Button text="Cancel" backgroundColor="#fff" color="#214160" />
                <ButtonWithBorder
                  disabled={step === 1 ? true : false}
                  text="Back"
                  onClick={previousStep}
                  backgroundColor="#fff"
                  color="#214160"
                />
                {step === totalSteps ? (
                  <SmallButton
                    text="Finish"
                    type="submit"
                    onClick={() => formikBag.handleSubmit()}
                  />
                ) : (
                  <SmallButton text="Next" onClick={nextStep} />
                )}
              </Footer>
            </Modal>
          )}
          <SearchInput />
          <ListContainer>
            {kpis &&
              kpis.map((kpi) => (
                <Accordion
                  kpi={kpi}
                  isConfig
                  showEdit={setEdit}
                  handleDelete={() => handleDelete(kpi.id)}
                />
              ))}
          </ListContainer>
        </KPIsContainer>
      )}
    </Formik>
  );
};

export default KPIConfigComponent360;

const KPIsContainer = styled.div`
  display: grid;
  grid-template-rows: 5em 4.25em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;

const WizzardHeader = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  border: 2px solid rgba(76, 92, 251, 0.1);
  border-radius: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const HeaderItem = styled.button<{ enabled: boolean }>`
  display: flex;
  font-size: 12;
  font-weight: 600;
  align-items: center;
  background-color: ${(props) => (props.enabled ? "#EBEFFF" : "#fff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 1em;
  width: 100%;
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  opacity: ${(props) => (props.enabled ? 1 : 0.4)};
  ${TitleText} {
    padding-left: 1em;
    color: #01A8CE;
    font-size: 12px;
  }
  &:focus {
    outline: none;
  }
`;

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1em;
`;

const ButtonWithBorder = styled(Button)<{ disabled: boolean }>`
  border: 2px solid #01A8CE;
  padding: 0.3em 4em;
  margin-left: auto;
  margin-right: 1em;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;

const SmallButton = styled(Button)`
  padding: 0.4em 4em;
  border: 2px solid #01A8CE;
`;

const ScoringContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 1fr;
`;

const ScoringSectionHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 1fr;
  ${TitleText} {
    color: #c4c9fe;
  }
`;

const ScoringSection = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 1.1fr 1fr 0.5fr;
  align-items: center;
  grid-gap: 1em;
  ${TitleText} {
    font-weight: normal;
    opacity: 0.9;
  }
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
